import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./Tip.scss";

export function Tip({
  className,
  step,
  children,
  onDismiss,
  activeStep,
  dismissLabel,
  onSetTipSelected,
  buttonStart,
  activeButtonLabel,
  hideSkipButton,
  ...rest
}) {
  const intl = useIntl();

  return (
    <div className={classNames(styles.tip, className)} {...rest}>
      <div className={styles.content}>{children}</div>
      {onDismiss && (
        <div className={styles.rightContainer}>
          {step && activeStep && (
            <div className={styles.steps}>
              <FormattedMessage
                id="tips.lobby-step"
                defaultMessage="{activeStep}/{steps}"
                values={{ steps: step.length - 2, activeStep }}
              />
            </div>
          )}

          <div className={styles.buttonsContainer}>
            {buttonStart && (
              <button
                className={classNames(styles.activeButton, styles.baseButton)}
                onClick={hideSkipButton ? onDismiss : onSetTipSelected}
              >
                {intl.formatMessage({
                  id: activeButtonLabel.id,
                  defaultMessage: activeButtonLabel.header
                })}
              </button>
            )}
            {!hideSkipButton && (
              <button className={classNames(styles.dismissButton, styles.baseButton)} onClick={onDismiss}>
                {dismissLabel}
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

Tip.propTypes = {
  className: PropTypes.string,
  step: PropTypes.array,
  onSetTipSelected: PropTypes.func,
  buttonStart: PropTypes.bool,
  hideSkipButton: PropTypes.bool,
  activeStep: PropTypes.number,
  activeButtonLabel: PropTypes.object,
  children: PropTypes.node,
  onDismiss: PropTypes.func,
  dismissLabel: PropTypes.node
};
